import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageHeaderWithButton } from '..';
import { useTable } from './useTable';
import { translate } from '../../../Services/translation';

export const CRUDTable = ({ model, createAction = "create", updateAction = "edit", updateBlockAction = "block", btnText = translate("coptikk.adminportal.create.new.buttontext") + " " + `${model.item}` }) => {
    const { root, headers, getData, deleteRequest, title, forbidCreateNew } = model;
    const history = useNavigate();

    const updateLinkUrl = (systemId) => `/${root}/${updateAction}/${systemId}`;

    const updateBlockLinkUrl = (systemId) => `/${root}/${updateBlockAction}/${systemId}`;

    const [table, updateTableData] = useTable(getData, deleteRequest, updateLinkUrl, updateBlockLinkUrl, headers, model);

    const createPage = () => history(`/${root}/${createAction}/`);

    return (
        <div className="backend__articles">
            <PageHeaderWithButton forbidCreateNew={forbidCreateNew} title={title} btnText={btnText} btnOnClick={() => createPage()} />
            {table}
        </div>
    )
};